import { render } from "./recordItemteacher.vue?vue&type=template&id=fc85339a&scoped=true"
import script from "./recordItemteacher.vue?vue&type=script&lang=js"
export * from "./recordItemteacher.vue?vue&type=script&lang=js"

import "./recordItemteacher.vue?vue&type=style&index=0&id=fc85339a&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc85339a"]])

export default __exports__